module.exports = __webpack_public_path__ + "img/lolita_hall.baab4272.jpg";